import React, { useEffect } from 'react';
import styled from 'styled-components';

const Backdrop = styled.div<{ isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background: var(--shadow-overlay);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;

  opacity: ${(p) => (p.isOpen ? 1 : 0)};
  pointer-events: ${(p) => (p.isOpen ? 'auto' : 'none')};
  transition: opacity 160ms ease-out;
`;

const Modal = styled.div<{ isOpen: boolean }>`
  width: 900px;
  max-width: calc(100vw - 32px);
  height: 600px;

  background: var(--color-bg-primary);
  border-radius: 16px;
  overflow: hidden;
  box-shadow:
    0 16px 40px rgba(0, 0, 0, 0.22),
    0 4px 14px rgba(0, 0, 0, 0.14);

  transform: ${(p) =>
    p.isOpen ? 'scale(1) translateY(0)' : 'scale(0.96) translateY(-8px)'};
  opacity: ${(p) => (p.isOpen ? 1 : 0)};

  transition:
    transform 180ms cubic-bezier(0.16, 1, 0.3, 1),
    opacity 120ms ease-out;

  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;

const SearchModal = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  return (
    <Backdrop isOpen={isOpen} onMouseDown={onClose}>
      <Modal isOpen={isOpen} onMouseDown={(e) => e.stopPropagation()}>
        <Body>{children}</Body>
      </Modal>
    </Backdrop>
  );
};

export default SearchModal;
